import { getTierIntersectionForFeature } from 'marketplace-ui-apps-core/installability/utils/featureCompatibilities';
import CoreCompatibilityModal from 'marketplace-ui-common/compatibility/components/FeatureCompatibilityModal';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureCompatibilityModal = ({
  appContext,
  features,
  onClose,
  installability,
  tierGroupNames,
  trackInteraction
}) => {
  const featuresWithTierCompatibility = features.map(feature => {
    var _installability$featu;
    const featureCompatibility = installability === null || installability === void 0 || (_installability$featu = installability.featureCompatibilities) === null || _installability$featu === void 0 ? void 0 : _installability$featu.find(compat => compat.featureId === feature.id);
    const tierIntersectionForFeature = getTierIntersectionForFeature(feature, featureCompatibility);
    return {
      text: feature.title,
      tiers: tierIntersectionForFeature
    };
  });
  return /*#__PURE__*/_jsx(CoreCompatibilityModal, {
    appContext: appContext,
    featuresWithTierCompatibility: featuresWithTierCompatibility,
    offeringType: "APP",
    onClose: onClose,
    portalTiers: (installability === null || installability === void 0 ? void 0 : installability.portalTiers) || [],
    requestState: installability ? RequestState.SUCCEEDED : RequestState.PENDING,
    tierGroupNames: tierGroupNames,
    trackInteraction: trackInteraction
  });
};